import React, { useState, useEffect } from "react";
import "../dash.css";
import DashHeader from "../../component/dash_header";
import DashMenu from "../../component/dash_menu";
import WithdrawalContent from "../../component/withdrawal_content";
import { Link, useParams } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import ChatBox from "../../component/chatbox";




const WithdrawalMethod = () => {
     // State initialization
    const { method } = useParams()




    const [isMenuVisible, setIsMenuVisible] = useState(window.innerWidth > 1100);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Toggle menu manually via button
    const toggleMenu = () => {
        setIsMenuVisible((prev) => !prev);
    };

    // Resize listener to update window width
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Sync menu visibility with screen width
    useEffect(() => {
        if (windowWidth > 1100) {
            setIsMenuVisible(true);
        } else {
            setIsMenuVisible(false);
        }
    }, [windowWidth]);






    return (
        <div className="dashboard">
            <DashHeader toggleMenu={toggleMenu} />
            <div className="dash_body_container">
                <DashMenu isMenuVisible={isMenuVisible} toggleMenu={toggleMenu} />
                <div className="dash_content_container">
                    <div className="dash_contain">
                        <div className="dash_head">
                            <h3>Withdrawal</h3>
                            <p>
                                <Link to="/withdrawal"><span style={{color:"rgba(255, 80, 80, 0.7)", cursor: "pointer"}}><FaArrowLeftLong style={{marginRight: "5px"}} />  See all Withdrawal method</span></Link>
                                 </p>
                        </div>


                        <div className="dash_payment_container">
                            
                            <WithdrawalContent method = {method}/>


                            <div className="terms_cover">
                                <div className="term_contain">
                                    <h4>Terms</h4>
                                    <li>Averge payment time <span>Instant</span></li>
                                    <li>Fee <span>0%</span></li>
                                </div>
                                <div className="term_contain">
                                    <h4>Notice</h4>
                                    <li><span>Double-check</span> all details before submitting.</li>
                                    <li>Instant payments cannot be <span>reversed.</span></li>
                                    <li>We are not liable for <span>input errors</span></li>
                                </div>
                            </div>



                        </div>

                    </div>
                </div>
            </div>
        <ChatBox />
        </div>
    )
}



export default WithdrawalMethod